import { types } from 'mobx-state-tree';

import { ShippingSelectionFieldTypeType } from '../types/ShippingSelectionFieldType';
import ShippingSelectionFieldOption from './ShippingSelectionFieldOption';

const ShippingOptionSelectionField = types.model(
  'ShippingOptionSelectionField',
  {
    id: types.identifierNumber,
    text: types.string,
    type: ShippingSelectionFieldTypeType,
    options: types.optional(types.array(ShippingSelectionFieldOption), [])
  }
);

export default ShippingOptionSelectionField;



// WEBPACK FOOTER //
// ./src/models/ShippingOptionSelectionField.js